// packages
import { useEffect, useState } from 'react';

// local
import http from '$shared/http.js';

export function useCountries() {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    http
      .get('/donate/countries')
      .json()
      .then((data) => {
        setCountries(data);
      });
  }, []);

  return countries;
}

export function useSubdivisions(countryCode) {
  const [subdivisions, setSubdivisions] = useState([]);

  useEffect(() => {
    http
      .get(`/donate/countries/${countryCode}`)
      .json()
      .then((data) => {
        setSubdivisions(data);
      });
  }, [countryCode]);

  return subdivisions;
}
